import React from "react";
import { FONTS } from "./constants";

export function CanvasLayer({ l, canvasSize, selected, startDrag, moveDrag, endDrag }) {
  const px = Math.round((l.x ?? 0.5) * canvasSize.w);
  const py = Math.round((l.y ?? 0.5) * canvasSize.h);
  const font = FONTS.find((f) => f.key === l.font);
  return (
    <div key={l.id}
      onPointerDown={(e) => startDrag(e, l.id)}
      onPointerMove={moveDrag}
      onPointerUp={endDrag}
      onPointerCancel={endDrag}
      className={`absolute cursor-grab active:cursor-grabbing select-none ${selected ? "outline outline-2 outline-[color:var(--accent-metal)]" : ""}`}
      style={{ top: 0, left: 0, touchAction: "none", willChange: "transform",
        transform: `translate(${px}px, ${py}px) translate(-50%, -50%) rotate(${l.rotation || 0}deg)` }}
      data-testid={`canvas-layer-${l.id}`}
    >
      <div>
      {l.type === "text" ? (
        <div style={{
          fontFamily: font?.family,
          fontStyle: font?.italic ? "italic" : "normal",
          fontSize: Math.min(l.size, Math.max(14, canvasSize.w * 0.14)),
          color: l.color,
          textShadow: "0 2px 8px rgba(0,0,0,0.35)",
          padding: 6,
          lineHeight: 1,
          whiteSpace: "nowrap",
          textAlign: "center",
        }}>{l.text}</div>
      ) : (
        <img src={l.src} alt="" draggable={false} style={{
          width: l.width, height: l.height, opacity: l.opacity,
          objectFit: "cover",
          filter: l.engraved
            ? `grayscale(1) contrast(${l.contrast ?? 1.6}) brightness(${l.brightness ?? 0.9})`
            : "none",
        }}/>
      )}
      </div>
    </div>
  );
}
